module.exports = __webpack_public_path__ + "assets/img/Novo_Family Nature_RGB_lr.868b40fc.jpg";